<template>
  <div class="content-wrap">
    <template v-for="item in Object.values(data)">
      <SensorChart v-bind="item" :color="color" :key="item.name" />
    </template>
  </div>
</template>

<script>
import SensorChart from './sensor-chart.vue';

export default {
  components: {
    SensorChart
  },
  props: {
    mod: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    data: {
      type: [Object, null],
      default: () => ({})
    }
  }
};
</script>

<style lang="scss">
.content-wrap {
  width: calc(100% + 18px);
  height: 65vh;
  overflow-y: scroll;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>
